"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function PlayIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M10.27,17.753a1.266,1.266,0,0,1-.541-.122A1.245,1.245,0,0,1,9.012,16.5V7.5a1.255,1.255,0,0,1,2.051-.971h0l5.466,4.5a1.254,1.254,0,0,1,0,1.938l-5.466,4.5A1.252,1.252,0,0,1,10.27,17.753Zm.441-9.308v7.11L15.032,12Z" }),
        react_1.default.createElement("path", { d: "M12,23.156a11.156,11.156,0,1,1,7.892-3.264A11.126,11.126,0,0,1,12,23.156ZM12,2.543A9.457,9.457,0,1,0,18.69,5.31,9.433,9.433,0,0,0,12,2.543Z" })));
}
exports.default = PlayIcon;
